// Simplified pricing-tabs.js
// Core responsibilities preserved: tab fetch, inline/external script execution, Seal init + plan selection, bundle presence ensure, toggle mapping.

window.__PRICING_DEBUG__ = false;

(function () {
    const DEBUG = () => window.__PRICING_DEBUG__;
    const debug = (...a) => { if (DEBUG()) console.log('[pricing-tabs]', ...a); };
    const SEAL_GLOBAL_WAIT = 3000;
    const isJsType = t => !t || ['text/javascript', 'application/javascript', 'module'].includes((t || '').trim().toLowerCase());
    const runInlineScripts = root => root?.querySelectorAll?.('script:not([src])').forEach(s => {
        if (s.dataset.executed) return;
        if (!isJsType(s.type)) return;
        const code = s.textContent || '';
        try { new Function(code); } catch (e) { debug('skip inline syntax error', code.slice(0, 80), e.message); return; }
        s.dataset.executed = 'true';
        const n = document.createElement('script'); n.text = code; s.replaceWith(n);
    });
    const executedExternal = new Set();
    const ensureExternalScripts = root => root?.querySelectorAll?.('script[src]')?.forEach(s => {
        if (!isJsType(s.type)) return;
        const src = s.getAttribute('src'); if (!src) return;
        if (executedExternal.has(src) || document.querySelector(`head script[src="${CSS.escape(src)}"]`)) return;
        const t = document.createElement('script'); t.src = src; t.async = false; t.onload = () => debug('loaded', src); document.head.appendChild(t); executedExternal.add(src);
    });
    // Ensure Router tab bundler widgets render using Bundler's API refresh (no script reload)
    // Prefer finishing early when Bundler emits its widget-created event
    function ensureBundlerLoaded(root, attempt = 0) {
        const MAX_ATTEMPTS = 10;
        const RETRY_BASE = 400; // ms
        const routerTab = (root && root.id === 'tab-router') ? root : document.getElementById('tab-router');
        const isRouterActive = () => !!(routerTab && !routerTab.classList.contains('hidden'));
        if (!isRouterActive()) { debug('[Bundler] skip refresh (router inactive)'); return; }
        const hasContainer = () =>
            !!(routerTab && routerTab.querySelector('.bndlr-products-container, .bndlr-product, [data-bndlr]'));

        if (hasContainer()) return Promise.resolve(true);

        return new Promise((resolve) => {
            let done = false;
            const resolveOnce = (ok) => {
                if (done) return;
                done = true;
                document.removeEventListener('bundler:bundle_widget_created', onBundleEvent);
                resolve(!!ok);
            };

            const onBundleEvent = () => {
                if (hasContainer()) return resolveOnce(true);
            };

            document.addEventListener('bundler:bundle_widget_created', onBundleEvent);

           
            setTimeout(() => {
                
                try {
                    if (window.bndlr && typeof window.bndlr.refresh === 'function') {
                        debug(`[Bundler] Refresh attempt #${attempt + 1}`);
                        window.bndlr.refresh();
                    } else {
                        debug('[Bundler] refresh() not ready yet');
                    }
                } catch (err) {
                    debug('[Bundler] refresh error', err);
                }
            }, 150); // wait a bit before refresh

            // Retry logic
            setTimeout(() => {
                if (done) return;
                if (hasContainer()) return resolveOnce(true);
                if (attempt < MAX_ATTEMPTS) {
                    ensureBundlerLoaded(routerTab || undefined, attempt + 1).then(resolveOnce);
                } else {
                    debug('[Bundler] Failed to load after max attempts');
                    resolveOnce(false);
                }
            }, RETRY_BASE * (attempt + 1));
        });
    }

    const waitFor = (testFn, timeout = 3000, step = 100) => new Promise(r => {
        const start = performance.now();
        if (testFn()) return r(true);
        const iv = setInterval(() => { if (testFn()) { clearInterval(iv); r(true); } else if (performance.now() - start > timeout) { clearInterval(iv); r(false); } }, step);
    });
    const normalize = s => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

    async function waitForSealGlobal() {
        return waitFor(() => typeof SealSubscription !== 'undefined', SEAL_GLOBAL_WAIT, 150);
    }
    async function initSeal(tabEl) {
        if (!tabEl) return false;

        const form = tabEl.querySelector('.product-form');
        if (!form) return false;
        await waitForSealGlobal();
        if (typeof SealSubscription === 'undefined') return false;
        const id = form.querySelector('[name="id"]')?.value;
        if (!id) return false;
        console.log('seal init from other ' + id);
        if (form._sealInitializedFor === id) return true;
        form.querySelectorAll('.seal-subscription-widget').forEach(e => e.remove());
        try { SealSubscription.init({ selector: form, productId: id }); form._sealInitializedFor = id; debug('seal init', id); } catch (e) { debug('seal init error', e); }
        return true;
    }
    function updatePlanSummary(tabEl, group) {
        if (!group) return;
        const opt = tabEl.querySelector(`.sls-option-container[data-selling-plan-group="${group}"]`);
        if (!opt) return;
        const title = tabEl.querySelector('.plan-title');
        const priceOut = tabEl.querySelector('.plan-price');
        const descOut = tabEl.querySelector('.plan-description');
        const nameEl = opt.querySelector('.sls-selling-plan-group-name');
        const priceEl = opt.querySelector('.sls-price .money');
        const descEl = opt.querySelector('.sls-selling-plan-description-content');
        if (title && nameEl) title.textContent = nameEl.textContent.trim();
        if (priceOut && priceEl) priceOut.textContent = priceEl.textContent.trim();
        if (descOut && descEl) descOut.innerHTML = descEl.innerHTML;
    }
    function mapTogglesToPlans(tabEl, scope) {
        const togglesWrap = tabEl.querySelector(scope);
        if (!togglesWrap) return;
        const toggles = [...togglesWrap.querySelectorAll('.toggle-option')];
        if (!toggles.length) return;
        const options = [...tabEl.querySelectorAll('.sls-option-container[data-selling-plan-group]')];
        if (!options.length) return; // will retry later
        const optionIndex = options.map(o => ({
            el: o,
            id: o.getAttribute('data-selling-plan-group'),
            annual: o.classList.contains('annual'),
            monthly: o.classList.contains('monthly'),
            name: normalize(o.querySelector('.sls-selling-plan-group-name')?.textContent || '')
        }));
        // Map toggles: prefer class-based mapping first
        toggles.forEach(btn => {
            const lbl = normalize(btn.textContent);
            let match = null;
            if (/annual|year/.test(lbl)) match = optionIndex.find(o => o.annual) || optionIndex.find(o => /annual|year/.test(o.name));
            else if (/month|mo/.test(lbl)) match = optionIndex.find(o => o.monthly) || optionIndex.find(o => /month|mo/.test(o.name));
            if (!match) { // fallback to substring
                match = optionIndex.find(o => o.name.includes(lbl));
            }
            if (match) btn.dataset.planGroup = match.id;
        });
        // Choose initial: annual preferred if present
        const initial = toggles.find(b => /annual|year/.test(normalize(b.textContent))) || toggles[0];
        toggles.forEach(b => b.classList.remove('active'));
        initial?.classList.add('active');
        if (initial?.dataset.planGroup) activatePlanGroup(tabEl, initial.dataset.planGroup);
        if (!togglesWrap._bound) {
            togglesWrap.addEventListener('click', e => {
                const b = e.target.closest('.toggle-option'); if (!b || !b.dataset.planGroup) return;
                toggles.forEach(x => x.classList.remove('active')); b.classList.add('active'); activatePlanGroup(tabEl, b.dataset.planGroup);
            });
            togglesWrap._bound = true;
        }
    }

    // Activate plan group by simulating vendor expected interactions (radio click) then syncing hidden & summary
    async function activatePlanGroup(tabEl, group) {
        if (!group) return false;
        const opt = tabEl.querySelector(`.sls-option-container[data-selling-plan-group="${group}"]`);
        if (!opt) return false;
        const radio = opt.querySelector('input[type="radio"][data-selling-plan-group]');
        if (radio) { try { radio.click(); } catch { } }
        else {
            // Fallback: click the first line container which has role=radio
            const firstLine = opt.querySelector('.sls-selling-plan-group-first-line[role="radio"]');
            if (firstLine) { try { firstLine.click(); } catch { } }
        }
        // Wait briefly for vendor script to update pricing DOM
        await new Promise(r => setTimeout(r, 120));
        // Sync hidden input
        const hidden = tabEl.querySelector('input[name="selling_plan"]');
        const sel = opt.querySelector('select');
        if (hidden && sel && sel.value && hidden.value !== sel.value) {
            hidden.value = sel.value;
            hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updatePlanSummary(tabEl, group);
        // Debug mismatch detection
        if (window.__PRICING_DEBUG__) {
            const title = tabEl.querySelector('.plan-title')?.textContent?.toLowerCase() || '';
            const nameTxt = opt.querySelector('.sls-selling-plan-group-name')?.textContent?.toLowerCase() || '';
            if (nameTxt && !title.includes(nameTxt.trim().split(/\s+/)[1] || '')) {
                debug('plan summary mismatch', { group, nameTxt, title });
            }
        }
        return true;
    }
    function reinitLogos(tabEl) {
        console.log('init logo');
        if (typeof window.initSection === 'function') {
            console.log('init list logo');
            let el = tabEl.querySelector('.swiper.js-slider-logos') || tabEl;
            console.log(el);
            try { window.initSection(el); } catch (e) { debug('initSection error', e); }
        }
        if (typeof window.swiperInit === 'function') window.swiperInit();
        if (window.initLogoSliders) window.initLogoSliders(tabEl);
    }
    const SUBSCRIPTION_TABS = new Set(['vpn', 'antivirus']);
    function loadTabOnce(slug, url) {
        const tabEl = document.getElementById('tab-' + slug); if (!tabEl) return;
        if (tabEl._loaded) return; tabEl._loaded = true;
        tabEl.innerHTML = '<div class="loading-spinner"></div>';
        fetch(url).then(r => r.text()).then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const main = doc.querySelector('#MainContent') || doc.querySelector('main');
            const newDesc = doc.querySelector('meta[name="description"]');
            tabEl.innerHTML = main ? main.innerHTML : '<p>Could not load content.</p>';
            runInlineScripts(tabEl); ensureExternalScripts(tabEl);
            // Fire section load events for any dynamically injected sections so their own JS can init sliders etc.
            tabEl.querySelectorAll('[data-section-id]').forEach(sec => {
                try { document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { target: sec } })); } catch { }
            });
            if (slug === 'router') {
                // Re-init router logos and ensure Bundler script is loaded after AJAX inject
                setTimeout(() => { reinitLogos(tabEl); }, 2000);
                setTimeout(() => { ensureBundlerLoaded(tabEl); }, 2000);
            }
            setTimeout(() => { initPerTab(slug, tabEl); }, 200);
            const metaDescTag = document.querySelector('meta[name="description"]');
            const content = newDesc?.getAttribute('content'); if (content && metaDescTag) metaDescTag.setAttribute('content', content);
        }).catch(e => { tabEl.innerHTML = '<p>Error loading content.</p>'; debug('fetch error', slug, e); });
    }
    function activateTab(slug) {
        const tabs = document.querySelectorAll('.tab-btn');
        const contents = document.querySelectorAll('.tab-content');
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.add('hidden'));
        const btn = document.querySelector(`.tab-btn[data-tab="${slug}"]`);
        const content = document.getElementById('tab-' + slug);
        if (!btn || !content) return;
        btn.classList.add('active'); content.classList.remove('hidden');
        setTimeout(() => { if (SUBSCRIPTION_TABS.has(slug)) { initSeal(content); } }, 200);
        // Ensure Bundler widgets render when switching back to Router tab
        if (slug === 'router') {
            setTimeout(() => { ensureBundlerLoaded(content); }, 150);
        }
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { target: content } }));
        const baseTitle = document.title.replace(/ - .+$/, '');
        document.title = `${baseTitle} - ${btn.dataset.label || slug}`;
        try {
            const u = new URL(window.location.href);
            u.searchParams.set('tab', slug);
            window.history.replaceState({}, '', u.toString());
        } catch { }
    }

    function updateBundleMonthly(root, attempt = 0) {
        // Allow calling with document to scan whole page
        if (!root) root = document;
        const MAX_ATTEMPTS = 10;
        const RETRY_BASE = 120; // ms

        const toNum = s => parseFloat(s.replace(/,(?=\d{3}(\D|$))/g, '').replace(',', '.'));
        const computeMonthly = (text) => {
            let monthlyValue = null;
            const perMonthMatch = text.match(/([0-9][\d.,]*)\s*\/\s*month/i);
            const perYearMatch = text.match(/([0-9][\d.,]*)\s*(?:per\s*year|\/\s*year)/i);
            if (perMonthMatch) {
                const m = toNum(perMonthMatch[1]);
                if (!isNaN(m) && m > 0) monthlyValue = m;
            } else if (perYearMatch) {
                const y = toNum(perYearMatch[1]);
                if (!isNaN(y) && y > 0) monthlyValue = y / 12;
            } else {
                const nums = (text.match(/[0-9]+[0-9.,]*/g) || []).map(toNum).filter(v => !isNaN(v) && v > 0);
                if (nums.length) {
                    if (nums.length >= 2) monthlyValue = Math.min(...nums);
                    else monthlyValue = nums[0] / 12;
                }
            }
            if (monthlyValue == null) return null;
            return Math.floor(monthlyValue * 100) / 100; // floor 2 decimals
        };

        const optionContainers = Array.from(root.querySelectorAll('.sls-option-container[data-selling-plan-group]'));
        const annualOpts = optionContainers.filter(opt => /annual/i.test(opt.querySelector('.sls-selling-plan-group-name')?.textContent || ''));

        if (!annualOpts.length) {
            if (attempt < MAX_ATTEMPTS) setTimeout(() => updateBundleMonthly(root, attempt + 1), RETRY_BASE * (attempt + 1));
            return false;
        }

        let updated = 0;
        annualOpts.forEach(opt => {
            const planNameEl = opt.querySelector('.sls-selling-plan-group-name');
            if (!planNameEl) return;
            const monthlyValue = computeMonthly(opt.textContent || '');
            if (monthlyValue == null) return;

            let formatted;
            if (typeof Intl !== 'undefined' && window.Shopify?.currency?.active) {
                try {
                    formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(monthlyValue);
                } catch {
                    formatted = `$${monthlyValue.toFixed(2)}`;
                }
            } else {
                formatted = '$' + monthlyValue.toFixed(2);
            }

            const next = planNameEl.nextElementSibling;
            if (next && next.classList.contains('bundle-monthly-inline')) {
                next.textContent = `${formatted}`;
            } else {
                const line = document.createElement('div');
                line.className = 'bundle-monthly-inline';
                line.textContent = `${formatted}`;
                planNameEl.insertAdjacentElement('afterend', line);
            }
            updated++;
        });

        // Also handle Bundler product cards that show "Pay $XX per year" (e.g., 3rd product card)
        const bundlerCards = Array.from((root || document).querySelectorAll('.bndlr-product'));
        bundlerCards.forEach(card => {
            // Skip if already has our line or already displays '/ month'
            if (card.querySelector('.bundle-monthly-inline')) return;
            if (/\/\s*month/i.test(card.textContent || '')) return;

            const txt = card.textContent || '';
            if (!/(per\s*year|\/\s*year)/i.test(txt)) return;
            const monthlyValue = computeMonthly(txt);
            if (monthlyValue == null) return;

            let formatted;
            if (typeof Intl !== 'undefined' && window.Shopify?.currency?.active) {
                try {
                    formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(monthlyValue);
                } catch {
                    formatted = `$${monthlyValue.toFixed(2)}`;
                }
            } else {
                formatted = '$' + monthlyValue.toFixed(2);
            }

            const titleEl = card.querySelector('.bndlr-product-title, .title, h3, h4, h5');
            const anchor = titleEl || card.firstElementChild || card;
            const line = document.createElement('div');
            line.className = 'bundle-monthly-inline';
            line.textContent = `${formatted} / month`;
            anchor.insertAdjacentElement('afterend', line);
            updated++;
        });

        if (!updated && attempt < MAX_ATTEMPTS) {
            setTimeout(() => updateBundleMonthly(root, attempt + 1), RETRY_BASE * (attempt + 1));
            return false;
        }
        return updated > 0;
    }

    // Event: bundler widget & seal subscription ready



    // --------------------------------------------------
    // Per-tab initialization after content injection
    // --------------------------------------------------
    async function initPerTab(slug, tabEl) {
        if (window.__PRICING_DEBUG__) debug('initPerTab start', slug);
        let sealHideTarget = null;
        if (SUBSCRIPTION_TABS.has(slug)) {

            // Insert loading spinner inside .custom-liquid placed right after .billing-changes
            try {
                const billing = tabEl.querySelector('.billing-changes');
                const customLiquid = billing?.parentElement?.querySelector('.custom-liquid');
                if ((customLiquid || billing) && !tabEl.querySelector('.vpn-plan-loading')) {
                    const loadEl = document.createElement('div');
                    loadEl.className = 'vpn-plan-loading';
                    loadEl.innerHTML = '<span class="vpn-spinner"></span><span>Loading plan…</span>';
                    // Preferred: insert AFTER billing-changes (visual flow)
                    if (billing && billing.parentNode) { billing.insertAdjacentElement('afterend', loadEl); }
                    else if (customLiquid) { customLiquid.prepend(loadEl); }
                    else { tabEl.prepend(loadEl); }
                    // record start for minimum duration
                    loadEl._start = performance.now();
                    tabEl._vpnLoadingEl = loadEl;
                }
            } catch (e) { debug('vpn spinner insert err', e); }
            // Try to scope hiding only to seal subscription container / block
            sealHideTarget = tabEl.querySelector('.sealsubs-target-element, .sealsubs-container, .sls-purchase-options-container');
            if (!sealHideTarget) {
                // lazy fallback: set a short polling to catch later injection before annual selection
                const pollStart = performance.now();
                const poll = setInterval(() => {
                    if (sealHideTarget || performance.now() - pollStart > 2500) { clearInterval(poll); return; }
                    sealHideTarget = tabEl.querySelector('.sealsubs-target-element, .sealsubs-container, .sls-purchase-options-container');
                    if (sealHideTarget && !sealHideTarget.classList.contains('seal-annual-hidden')) sealHideTarget.classList.add('seal-annual-hidden');
                }, 120);
            }
            if (sealHideTarget && !sealHideTarget.classList.contains('seal-annual-hidden')) {
                sealHideTarget.classList.add('seal-annual-hidden');
            }
        }
        initSeal(tabEl).then(() => {
            waitFor(() => tabEl.querySelector('.sls-option-container'), 5000, 150).then(async () => {
                if (SUBSCRIPTION_TABS.has(slug)) {
                    if (window.__PRICING_DEBUG__) debug('init for seal');
                    mapTogglesToPlans(tabEl, '.billing-toggle');
                    // Ensure annual activated before showing (if exists)
                    const annualOpt = tabEl.querySelector('.sls-option-container.annual[data-selling-plan-group]');
                    if (annualOpt) {
                        const group = annualOpt.getAttribute('data-selling-plan-group');
                        if (group) await activatePlanGroup(tabEl, group);
                        // Wait a short period for hidden input sync (or until it has value)
                        await waitFor(() => { const h = tabEl.querySelector('input[name="selling_plan"]'); return !!h?.value; }, 1500, 120);
                    } else {
                        // No annual plan => fallback after short delay
                        await new Promise(r => setTimeout(r, 200));
                    }

                    // Reveal only the seal subscription block (or nothing if not found)
                    const revealTarget = sealHideTarget || tabEl.querySelector('.sealsubs-target-element, .sealsubs-container, .sls-purchase-options-container');
                    if (revealTarget) {
                        requestAnimationFrame(() => {
                            revealTarget.classList.add('seal-annual-visible');
                            revealTarget.classList.remove('seal-annual-hidden');
                            // Remove spinner after short fade
                            // spinner removed
                            if (tabEl._vpnLoadingEl) {
                                const minVisible = 400; // ms
                                const elapsed = performance.now() - (tabEl._vpnLoadingEl._start || 0);
                                const wait = elapsed >= minVisible ? 60 : (minVisible - elapsed);
                                setTimeout(() => { try { tabEl._vpnLoadingEl.remove(); } catch { }; tabEl._vpnLoadingEl = null; }, wait);
                            }
                        });
                    }

                }

            });
        });
    }
    const contentsRoot = document.querySelectorAll('.tab-content');
    const inlineObserver = new MutationObserver(muts => {
        muts.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) runInlineScripts(n); }));
    });
    contentsRoot.forEach(c => inlineObserver.observe(c, { childList: true, subtree: true }));
    document.addEventListener('DOMContentLoaded', () => {
        const getBundleTabRoot = () => document.getElementById('tab-bundle');
        const tabs = document.querySelectorAll('.tab-btn');
        tabs.forEach(t => {
            const slug = t.dataset.tab;
            const url = t.dataset.url;
            if (!url) {
                const tabEl = document.getElementById('tab-' + slug);
                if (tabEl) tabEl._loaded = true;
                return;
            }
            loadTabOnce(slug, url);
        });

        const params = new URLSearchParams(window.location.search);
        const start = params.get('tab') || (tabs[0]?.dataset.tab);
        if (start) activateTab(start);
        tabs.forEach(t => t.addEventListener('click', function () { activateTab(this.dataset.tab); }, { passive: true }));

        document.addEventListener('bundler:bundle_widget_created', () => {
            const bundleRoot = getBundleTabRoot();
            if (bundleRoot) updateBundleMonthly(bundleRoot, 0);
        });
        // Fallback: when Seal subscription widget finishes rendering
        document.addEventListener('sealsubs:subscription_widget_created', () => {
            const bundleRoot = getBundleTabRoot();
            if (bundleRoot) updateBundleMonthly(bundleRoot, 0);
        });
    });
})();